import React from "react";
import cx from "classnames";
import styles from "./GetOnPlayStoreBadge.module.css"; // replace with your actual stylesheet path
import { storeLinkProps, STORES, PLACEMENTS } from "../../utils/storeLinks";

export const GetOnPlayStoreBadge = ({ errorText }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <a {...storeLinkProps(STORES.PLAY, PLACEMENTS.PLAY_BADGE)}>
        <img
          src="https://www.svgrepo.com/show/303139/google-play-badge-logo.svg"
          alt="Play Store Logo"
          style={{
            height: 300,
            width: 300,
          }}
        />
      </a>
    </div>
  );
};
